import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { AuthenticationService } from '../api/authentication/authentication.service';

import { Observable } from 'rxjs';

@Injectable()
export class AzureTokenInterceptor implements HttpInterceptor {
  readonly authService: AuthenticationService = inject(AuthenticationService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.isOnlineRequest(req)) {
      return next.handle(req); // Bypass the interceptor
    }

    const resourceNeedsToken = this.authService.resourceNeedsToken(req.url);
    const token = this.authService.token.getValue();
    if (!resourceNeedsToken || !token) return next.handle(req); // Bypass the interceptor

    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next.handle(clonedReq);
  }

  private isOnlineRequest(req: HttpRequest<unknown>): boolean {
    // To determine if the request is an 'isonline' request.
    return req.url.includes(`IsOnline`);
  }
}
